export const Id = (
  (i) => () =>
    i++
)(0);

export class NotificationTimer {
  handle: number | null;

  private callback: CallableFunction;
  private delayMs: number;

  constructor(callback: CallableFunction, delayMs: number) {
    this.handle = null;
    this.callback = callback;
    this.delayMs = delayMs;

    this.resume();
  }

  pause() {
    if (this.handle) {
      clearTimeout(this.handle);
      this.handle = null;
    }
  }

  resume() {
    if (this.handle)
      clearTimeout(this.handle);

    this.handle = setTimeout(this.callback, this.delayMs);
  }
}
